export default __webpack_public_path__ + "static/media/xls.7ea3c848.svg";